import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { mergeStyles, TextField, PrimaryButton } from '@fluentui/react';
import * as Helper from '../../Helpers/Helper';
import GearLoader from '../Shared/GearLoader';
import { styled } from '@mui/material/styles';
import darklogo from "../../static/images/kapton-logo.png";
import mslogo from "../../static/images/ms.ico";
import success from "../../static/images/success.png"
import verified from "../../static/images/verified.png";
import applogo from "../../static/images/applogo.png";

const backgroundStyles = mergeStyles({
  backgroundSize: 'cover',
  padding: '50px',
  width: 'auto%',
  minHeight: '600px',
  '@media (max-width: 768.99px)': {
    width: '100%',
  },
});
const lightBorderstyle = {
  BorderColor: '#eceff1',
  borderWidth: '1px',
  borderStyle: 'Solid'
};
const CustomContainer = styled(Container)(({ theme }) => ({
  maxWidth: '1500px',
  [theme.breakpoints.up('lg')]: {
    maxWidth: '1200px'
  }
}));

const TenantRegistration = (props) => {
  const preProps = { ...props };
  const [state, setState] = useState({
    activeStep: 'signin',
    orgName: '',
    authProvider: props.authProvider,
    isAuthenticated: false,
    chkConfirm: true,
    userInfo: '',
    isloading: false,
    isTenantRegistered: false,
    tenantId: '',
    tenantName: '',
    clientid: '',
    errorMessage: '',
    disabledbtn: true,
    currentProcess: '1',
    existsMessage: '',
    hostUrl: '',
    isLicensed: false,
    isSaaSConversion: false,
  })

  useEffect(() => {
    initializeAuthProvider();
    const { orgName, errorMessage } = state;
    if (orgName)
      setState(prevData => ({ ...prevData, disabledbtn: false }));
    else
      setState(prevData => ({ ...prevData, disabledbtn: true }));
  }, [state.orgName, state.errorMessage]);

  const initializeAuthProvider = async () => {
    let res = { "user": true, "isLicensed": false, "isSaaSConversion": false } //await Helper.postWebAPIResponseWithJSON('', `api/registration/get`, request);
    if (res.user || res.isLicensed || res.isSaaSConversion) {
      if (state.authProvider != null && props.userToken.idToken != '') {
        var userInfo = state.authProvider.getAccountInfo();
        if (userInfo) {
          setState(prevData => ({
            ...prevData,
            isAuthenticated: true,
            activeStep: 'configure',
            userInfo: userInfo.account,
            isloading: false,
            isLicensed: res.isLicensed,
            isSaaSConversion: res.isSaaSConversion
          }));
        }
      }
      else if (res.isLicensed || res.isSaaSConversion) {
        setState(prevData => ({
          ...prevData,
          isloading: false,
          isLicensed: res.isLicensed,
          isSaaSConversion: res.isSaaSConversion
        }));
      }
    }
    else {
      window.location = window.location.origin;
    }
  };

  const handleComplete = () => {
    if (state.hostUrl !== "") {
      window.location = state.hostUrl;
    }
    else {
      window.location = `https://${props.userToken.prefix}${state.subdomainName}.${props.userToken.domain}`;
    }
  }

  const handleStep2Next = () => {
    const userToken = `${props.userToken.idToken}.msal=${props.userToken.tid}`;
    setState(prevData => ({
      ...prevData,
      isloading: true
    }))
    var authProvider = state.authProvider;
    authProvider.getAccessToken().then(token => {
      Helper.fetchGraphAPIResponse(token.accessToken, "/organization", 'v1.0', props.userToken.tid).then(response => {
        if (response.value.length > 0) {
          var tenantId = response.value[0].id;
          var displayName = response.value[0].displayName;
          const request = {
            tenantName: displayName,
            tenantId: tenantId
          };
          Helper.fetchWebAPIResponseJson(userToken, `api/tenant/get?id=${tenantId}`, tenantId).then(data => {
            if (data.message !== null) {
              setState(prevData => ({
                ...prevData,
                activeStep: 'complete',
                isloading: false,
                isTenantRegistered: true,
                existsMessage: "Your tenant is already provisioned.",
                hostUrl: data.message
              }));
            }
            else {
              registerTenant(token.accessToken, request);
            }
          });
        }
      })
    })    
  };

  const registerTenant = async (accessToken, request) => {
    const userToken = `${props.userToken.idToken}.msal=${props.userToken.tid}`;
    const body = JSON.stringify({
      orgName: state.orgName,
      email: state.userInfo.userName,
      userId: state.userInfo.accountIdentifier,
      userName: state.userInfo.name,
      isRegisterTenant: 0,
      tenantName: request.tenantName,
      tenantId: request.tenantId
    });
    setState(prevData => ({
      ...prevData,
      isloading: true
    }))
    const response = await Helper.postWebAPIResponseWithJSON(userToken, `api/tenant/register`, body, request.tenantId)
    if (response) {
      setState(prevData => ({ ...prevData, activeStep: 'process', isloading: false }));
      createAppRegistration(accessToken, request);
    }
  }

  const createAppRegistration = async (accessToken, request) => {
    setState(prevData => ({ ...prevData, isloading: true }));
    try {
      Helper.fetchGraphAPIResponse(accessToken, "applications?$count=true", 'v1.0', request.tenantId).then(resp => {
        if (resp && resp.error) {
          setState(prevData => ({ ...prevData, isloading: false }));
        } else {
          if (resp.value.length > 0) {
            let arr = resp.value;
            let isAppFound = false;
            setState(prevData => ({
              ...prevData,
              currentProcess: '1'
            }));
            arr.forEach(item => {
              if (item.displayName.toLowerCase().indexOf("kapton") > -1) {
                isAppFound = true;
              }
            });
            if (isAppFound) {
              const app = arr.filter(t => t.displayName.toLowerCase() === "kapton")
              const url = `applications/${app[0].id}`
              Helper.deleteResponse(accessToken, url, 'v1.0', request.tenantId).then(res => {
                if (res && res.error) {
                  isAppFound = true;
                }
                else {
                  isAppFound = false;
                }
                if (!isAppFound) {
                  setState(prevData => ({ ...prevData, isloading: true }));
                  registerApp(accessToken, request);
                }
                else {
                  setState(prevData => ({
                    ...prevData,
                    activeStep: 'complete',
                    isloading: false,
                    isTenantRegistered: true,
                    existsMessage: "Your app is already registered, Please delete Kapton application registration from azure and try again!"
                  }));
                }
              })
            }
            else {
              setState(prevData => ({ ...prevData, isloading: true }));
              registerApp(accessToken, request);
            }
          }
          else {
            setState(prevData => ({ ...prevData, isloading: true }));
            registerApp(accessToken, request);
          }
        }
      });
    } catch (error) {
      setState(prevData => ({ ...prevData, isloading: false }));
    }
  }

  const registerApp = (accessToken, request) => {
    var body = JSON.stringify({
      "displayName": "kapton",
      "spa": { "redirectUris": [`https://compliance.kaptoncyclotron.com`] }
    });
    Helper.fetchPOSTGraphAPI(accessToken, 'applications', body, 'v1.0', request.tenantId).then(res => {
      if (res && res.error) {
        setState(prevData => ({ ...prevData, isloading: false }));
      }
      else {
        request = { ...request, objectId: res.id, appId: res.appId };
        createServicePrinciple(accessToken, request);
      }
    });
  }

  const createServicePrinciple = (accessToken, request) => {
    let url = `servicePrincipals`;
    let body = JSON.stringify({
      "appId": request.appId,
    });
    Helper.fetchPOSTGraphAPI(accessToken, url, body, 'v1.0', request.tenantId).then(res => {
      if (res && res.error) {
        setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while creating service priniciple. Please check your permission or try after some time" }))
      } else {
        request = { ...request, servicePrincipalId: res.id }
        getResourceIds(accessToken, request);
        assignComplianceAdminRole(accessToken, request)
      }
    });
  }
  const assignComplianceAdminRole = (accessToken, request) => {
    let roleUrl = `roleManagement/directory/roleAssignments`;
    const body = JSON.stringify({
      principalId: request.servicePrincipalId,
      roleDefinitionId: "17315797-102d-40b4-93e0-432062caca18", // Compliance Admin Role ID
      directoryScopeId: "/"
    });
    Helper.fetchPOSTGraphAPI(accessToken, roleUrl, body, 'v1.0', request.tenantId).then(res => {
      if (res && res.error) {
        setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while creating service priniciple. Please check your permission or try after some time" }))
      }
    });
  };

  const getResourceIds = (accessToken, request) => {
    setState(prevData => ({ ...prevData, isloading: true }));
    let graphResourceId = "", exchangeResourceId = "", sharepointResourceId = "", managementAPIResourceId = "";
    let url = "servicePrincipals?$filter=displayName eq 'Microsoft Graph' or displayName eq 'Office 365 SharePoint Online' or displayName eq 'Office 365 Management APIs' or displayName eq 'Office 365 Exchange Online'&$select=id,displayName";
    Helper.fetchGraphAPIResponse(accessToken, url, 'v1.0', request.tenantId).then(res => {
      if (res && res.error) {
        setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while access resource Ids. Please check your permission or try after some time." }))
      }
      else if (res.value.length > 0) {
        res.value.map(t => {
          if (t.displayName === "Microsoft Graph") {
            graphResourceId = t.id
          }
          if (t.displayName === "Office 365 Exchange Online") {
            exchangeResourceId = t.id
          }
          if (t.displayName === "Office 365 SharePoint Online") {
            sharepointResourceId = t.id
          }
          if (t.displayName === "Office 365 Management APIs") {
            managementAPIResourceId = t.id
          }
        })
        request = {
          ...request, graphResourceId: graphResourceId,
          exchangeResourceId: exchangeResourceId, sharepointResourceId: sharepointResourceId,
          managementAPIResourceId: managementAPIResourceId
        }
        setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "" }));
        updateDelegatePermission(accessToken, request);
        updateApplicationPermission(accessToken, request);
        setDirectoryRoleMemberExchange(accessToken, request);
        uploadCertificateKey(accessToken, request);
      }
    })
  }

  const updateDelegatePermission = (accessToken, request) => {
    setState(prevData => ({ ...prevData, isloading: true }));
    let url = "oauth2PermissionGrants";
    let scopes = "user_impersonation User.Read.All ";
    let body = JSON.stringify({
      "clientId": request.servicePrincipalId,
      "consentType": "AllPrincipals",
      "expiryTime": "2024-05-12T19:34:28.9831598Z",
      "principalId": null,
      "resourceId": request.graphResourceId,
      "scope": scopes
    })
    Helper.fetchPOSTGraphAPI(accessToken, url, body, 'v1.0', request.tenantId).then(res => {
      if (res && res.error) {
        setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while updating API deletegate Permissions. Please check your permission or try after some time." }))
      }
      else {
        setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "" }));
      }
    })
  }

  const updateApplicationPermission = (accessToken, request) => {
    setState(prevData => ({ ...prevData, isloading: true }));
    let url = "servicePrincipals/" + request.servicePrincipalId + "/appRoleAssignments";
    let arr = [
      "b0afded3-3588-46d8-8b3d-9842eff778da",
      // "41094075-9dad-400e-a0bd-54e686782033", //PERMISSION ID IS INVALID
      "e0fd9c8d-a12e-4cc9-9827-20c8c3cd6fb8",
      //"19dbc75e-c2e2-444c-a770-ec69d8559fc7",
      "5b567255-7703-4780-807c-7be8301ae99b",
      "6e472fd1-ad78-48da-a0f0-97ab2c6b769e",
      "19da66cb-0fb0-4390-b071-ebc76a349482",
      "b633e1c5-b582-4048-a93e-9f11b44c7e96",
      "246dd0d5-5bd0-4def-940b-0421030a5b68",
      "ed4fca05-be46-441f-9803-1873825f8fdb",
      "d903a879-88e0-4c09-b0c9-82f6a1333f84",
      "34bf0e97-1971-4929-b999-9e2442d941d7",
      "df021288-bdef-4463-88db-98f22de89214",
      "e2f98668-2877-4f38-a2f4-8202e0717aa1",
      "678536fe-1083-478a-9c59-b99265e6b0d3",
      "01d4889c-1287-42c6-ac1f-5d1e02578ef6",
      "dc50a0fb-09a3-484d-be87-e023b12c6440",
      "332a536c-c7ef-4017-ab91-336970924f0d"
    ]
    for (let i = 0; i < arr.length; i++) {
      let body = '';
      if (arr[i] === 'dc50a0fb-09a3-484d-be87-e023b12c6440') {
        body = JSON.stringify({
          "principalId": request.servicePrincipalId,
          "resourceId": request.exchangeResourceId, //Office 365 Exchange Online
          "appRoleId": arr[i]
        });
      }
      else if (arr[i] === '678536fe-1083-478a-9c59-b99265e6b0d3') {
        body = JSON.stringify({
          "principalId": request.servicePrincipalId,
          "resourceId": request.sharepointResourceId, //Office 365 SharePoint
          "appRoleId": arr[i]
        });
      }
      else {
        body = JSON.stringify({
          "principalId": request.servicePrincipalId,
          "resourceId": request.graphResourceId, // Microsoft Graph
          "appRoleId": arr[i]
        });
      }
      Helper.fetchPOSTGraphAPI(accessToken, url, body, 'v1.0', request.tenantId).then(res => {
        if (res && res.error) {
          setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while updating API application Permissions. Please check your permission or try after some time." }))
        }
        else {
          setState(prevData => ({ ...prevData, activeStep: 'process' }));
        }
      })
    }
  }

  const setDirectoryRoleMemberExchange = (accessToken, request) => {
    const body = JSON.stringify({
      '@odata.id': `${Helper.AppSettings.graphAPIhost}/v1.0/directoryObjects/${request.servicePrincipalId}`
    });
    Helper.fetchGraphAPIResponse(accessToken, "directoryRoles?$filter=displayName eq 'Exchange Administrator'", 'v1.0').then(res => {
      if (res.value.length > 0) {
        res.value.forEach(item => {
          let url = `directoryRoles/${item.id}/members/$ref`;
          Helper.fetchPOSTGraphAPI(accessToken, url, body, 'v1.0').then(() => {
            setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "" }));
          })
        })
      }
      setDirectoryRoleMemberCompliance(accessToken, request, body)
    })
  }

  const setDirectoryRoleMemberCompliance = (accessToken, request, body) => {
    Helper.fetchGraphAPIResponse(accessToken, "directoryRoles?$filter=displayName eq 'Compliance Administrator'", 'v1.0').then(res => {
      if (res.value.length > 0) {
        res.value.forEach(item => {
          let url = `directoryRoles/${item.id}/members/$ref`;
          Helper.fetchPOSTGraphAPI(accessToken, url, body, 'v1.0').then(() => {
            setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "" }));
          })
        })
      }
      else {
        setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "" }));
      }
    })
  }

  const uploadCertificateKey = (accessToken, request) => {
    const userToken = `${props.userToken.idToken}.msal=${props.userToken.tid}`;
    Helper.fetchWebAPIResponseJson(userToken, `api/registration/cert`, request.tenantId).then(res => {
      if (res) {
        res = res.data;
        let body = JSON.stringify({
          "keyCredentials": [{
            "type": "AsymmetricX509Cert",
            "usage": "Verify",
            "key": res.type,
            "displayName": res.displayName
          }]
        });
        let url = `applications/${request.objectId}`;
        Helper.fetchPATCHGraphAPI(accessToken, url, body, 'v1.0', request.tenantId).then(res => {
          if (res && res.error) {
            setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while uploading cerificates. Please check your permission or try after some time." }))
          }
          else {
            setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "", currentProcess: '4' }));
            uploadlogo(accessToken, request);
          }
        });
      }
    });
  }

   const uploadlogo = (accessToken, request) => {
    const logoUrl = applogo;
    fetch(logoUrl).then(r => r.arrayBuffer()).then(response => {
      let url = `applications/${request.objectId}/logo/`;
      Helper.fetchPUTGraphAPI(accessToken, url, response, "image/png", 'v1.0',state.tenantId).then(res => {
        if (res && res.error) {
          setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while updating application logo. Please check your permission or try after some time" }))
        }
        else {
          setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "" }));
          updateAppInfo(accessToken, request);
        }
      });
    });
  }

  const updateAppInfo = (accessToken, request) => {
    setState(prevData => ({ ...prevData, isloading: true }));
    let url = `applications/` + request.objectId;
    let body = JSON.stringify({
      "info": {
        "termsOfServiceUrl": "https://cyclotron.com/privacy-policy/",
        "supportUrl": "https://help.kaptoncyclotron.com/",
        "privacyStatementUrl": "https://cyclotron.com/privacy-policy/",
        "marketingUrl": "https://kapton.io",
        "logoUrl": ""
      },
      "web": {
        "homePageUrl": `https://compliance.kaptoncyclotron.com`,
        "logoutUrl": null,
        "implicitGrantSettings": {
          "enableIdTokenIssuance": true,
          "enableAccessTokenIssuance": true
        }
      }
    })
    Helper.fetchPATCHGraphAPI(accessToken, url, body, 'v1.0',state.tenantId).then(res => {
      if (res && res.error) {
        setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while updating application settings. Please check your permission or try after some time" }))
      }
      else {
        setState(prevData => ({ ...prevData, activeStep: 'process', errorMessage: "" }));
        //getDirectorySettings(accessToken, request);
        getDomains(accessToken, request);
      }
    });
  }

  const getDirectorySettings = (accessToken, request) => {
    setState(prevData => ({ ...prevData, isloading: true }));
    Helper.fetchGraphAPIResponse(accessToken, "groupSettings", 'v1.0', request.tenantId).then(settings => {
      if (settings.value.length === 0) {
        Helper.fetchGraphAPIResponse(accessToken, "groupSettingTemplates", 'v1.0', request.tenantId).then(res => {
          if (res.value.length > 0) {
            res.value.forEach(setting => {
              if (setting.displayName === "Group.Unified") {
                let settingObject = []
                setting.values.map(item => {
                  settingObject.push({ name: item.name, value: item.defaultValue })
                });
                const body = JSON.stringify({
                  templateId: setting.id,
                  values: settingObject
                });
                const url = `/groupSettings`;
                Helper.fetchPOSTGraphAPI(accessToken, url, body, 'v1.0', request.tenantId).then(reponse => {
                  if (reponse && reponse.error) {
                    setState(prevData => ({ ...prevData, isloading: false, activeStep: 'complete', errorMessage: "Something went wrong while verifying the group settings. Please check your permission or try after some time" }))
                  } else {
                    if (reponse !== null) {
                      getDomains(accessToken, request);
                    }
                  }
                });
              }
            })
          }
        })
      }
      else {
        getDomains(accessToken, request);
      }
    })
  }

  const getDomains = (accessToken, request) => {
    setState(prevData => ({ ...prevData, isloading: true }));
    Helper.fetchGraphAPIResponse(accessToken, "/domains", 'v1.0', request.tenantId).then(res => {
      if (res.value.length > 0) {
        res.value.forEach(item => {
          if (item.isInitial) {
            request.initialDomain = item.id;
          }
          if (item.isDefault) {
            request.defaultDomain = item.id;
            request.isTenantRegistered = 1;
          }
        });
      }
      updateTenantInfo(request);
    });
  }

  const updateTenantInfo = (request) => {
    const userToken = `${props.userToken.idToken}.msal=${props.userToken.tid}`;
    setState(prevData => ({ ...prevData, isloading: true }));
    request.IsRegisterTenant = 1;
    Helper.postWebAPIResponseWithJSON(userToken, `api/tenant/update`, JSON.stringify(request), request.tenantId).then(res => {
      setState(prevData => ({ ...prevData, activeStep: 'complete', errorMessage: "" }));
      completeApp();
    })
  }
  const completeApp = () => {
    window.location.href = "https://compliance.kaptoncyclotron.com"
    setTimeout(() => window.close(), 500);
  }

  const { authProvider, activeStep, isAuthenticated,
    orgName,
    errorMessage,
    disabledbtn,
    currentProcess,
    existsMessage    
  } = state;
  const { store } = props;
  return (
    <div>
      <div className='main'>
        <div className='scrollable-container'>
          <div className='container'>
            <CustomContainer maxWidth="lg">
              <div className='cardDetails '>
                <Grid container>
                  <Grid item lg={6} xl={6} sm={12} sx={{ bgcolor: "#f3f2f1", borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px" }}>
                    <div className="col-rt-12" >
                      <Grid container spacing={2} sx={{ mb: 4 }} className='boxwidth'>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div >
                            <h1 className='headings'>Provision your Kapton Instance</h1>
                          </div>
                        </Grid>
                      </Grid>
                      <div className="Scriptcontent">
                        <div className={`step ${activeStep === 'signin' && 'step-active'}`} sx={{}}>
                          <div>
                            <div className="circle"></div>
                          </div>
                          <div className='step-active'>
                            <div className="title">Sign In</div>
                            <div className="caption">Grant Global Admin consent to analyse your own data in Kapton.</div>
                          </div>
                        </div>
                        <div className={`step ${activeStep === 'configure' && 'step-active'}`} sx={{ height: "80px", padding: '0 0 15px 66px', marginBottom: '10px' }}>
                          <div>
                            <div className="circle"></div>
                          </div>
                          <div className='step-active'>
                            <div className="title">Configure</div>
                            <div className="caption">{'Setup your instance so we can customize to your needs.'}</div>
                          </div>
                        </div>
                        <div className={`step ${activeStep === 'process' && 'step-active'}`} sx={{ height: "80px", padding: '0 0 15px 66px', marginBottom: '10px' }}>
                          <div>
                            <div className="circle"></div>
                          </div>
                          <div className='step-active'>
                            <div className="title">Process</div>
                            <div className="caption">Sit back and relax while we make everything ready for you to start exploring.</div>
                          </div>
                        </div>
                        <div className={`step ${activeStep === 'complete' && 'step-active'}`} sx={{ height: "80px", padding: '0 0 15px 66px', marginBottom: '70px' }}>
                          <div>
                            <div className="circle"></div>
                          </div>
                          <div className='step-active'>
                            <div className="title">Complete</div>
                            <div className="caption">Explore and analyze with your own data.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} xl={6} sm={12} className={backgroundStyles} style={{ padding: "0px", alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                    {activeStep === 'signin' && <div>
                      {authProvider != null && !isAuthenticated &&
                        <AzureAD provider={authProvider} reduxStore={store}>
                          {({ login, logout, authenticationState }) => {
                            if (authenticationState === AuthenticationState.Authenticated) {
                              setState(prevData => ({ ...prevData, activeStep: 'configure', isAuthenticated: true }));
                              initializeAuthProvider();
                            }
                            else if (authenticationState === AuthenticationState.Unauthenticated) {
                              return (
                                <div className='aligncenter'>
                                  <img src={darklogo} alt="Kapton" className="responsive-image" />
                                  <h3>Login with your <br /> Global Administrator Account</h3>
                                  <PrimaryButton
                                    className="signupBtn"
                                    onClick={async () => {
                                      sessionStorage.clear();
                                      localStorage.clear();

                                      try {
                                        const result = await authProvider.login({
                                          prompt: "select_account",
                                          scopes: ["openid", "profile", "email"],
                                        });

                                        console.log("Login Success:", result.account);
                                      } catch (error) {
                                        console.error("Login Error:", error);
                                      }
                                    }}
                                    style={{ margin: "20px" }}
                                  >
                                    Sign in
                                  </PrimaryButton>
                                  <div>
                                    You will be redirected to the <br />
                                    <img src={mslogo} alt="Microsoft" /> <b>Microsoft account sign-in page</b>
                                  </div>
                                </div>
                              );
                            }
                          }}
                        </AzureAD>
                      }
                    </div>}
                    {activeStep === 'configure' &&
                      <div className="ms-Grid configure">
                        <div className="ms-Grid-row" >
                          <div className="ms-sm12 ms-md12 ms-lg12">
                            <div className='error'>{errorMessage}</div>
                          </div>
                          <div className="ms-sm12 ms-md12 ms-lg12">
                            <h3 className='title' id="filterNameToolTip" required >Organization Name</h3>
                            <div className='inline'>
                              <TextField ariaLabel="Required without visible label"
                                style={{ fieldGroup: lightBorderstyle, border: 'none' }}
                                id="txtorgName"
                                className="txtFilterName width100p"
                                placeholder="Enter your of your organization name"
                                value={orgName}
                                onChange={ev => { setState(prevData => ({ ...prevData, orgName: ev.target.value })) }}
                              />
                              {orgName !== "" && <img className='marginLeft10' src={verified} alt="Verified." />}
                            </div>
                          </div>
                        </div>
                        <div sx={{ mb: 2, mt: 4 }}>
                          <div>
                            <PrimaryButton
                              className={"signupBtn marginTop30 " + (disabledbtn ? 'btngray' : '')}
                              onClick={handleStep2Next}
                              disabled={disabledbtn}
                              text='Continue'
                            />
                          </div>
                        </div>
                      </div>}
                    {activeStep === 'process' && <div sx={{ mb: 2 }}>
                      <div className='alignCenter'>
                        <div className='textPadding'>
                          <h2>Thanks! We are processsing your request</h2>
                          <p>Your Kapton instance being provisioned and this might take couple of minutes.</p>
                          <h4 className='marginTop30'>Setting up custom properties ({currentProcess}/6)</h4>
                          {state.isloading ? <div className='marginCenter'><GearLoader /></div> : ""}
                        </div>
                      </div>
                    </div>}
                    {activeStep === 'complete' && <div sx={{ mb: 2 }}>
                      <div className="ms-sm12 ms-md12 ms-lg12">
                        <div className='error'>{existsMessage}</div>
                      </div>
                      <div className='alignCenter'>
                        <div className='textPadding'>
                          <h2>Thanks! You're good to go!</h2>
                          <div><img src={success} alt='Kapton' width={300} /></div>
                          <PrimaryButton
                            className="signupBtn marginTop30 width150"
                            onClick={handleComplete}
                            disabled={disabledbtn}
                            text='Open Kapton'
                          />
                        </div>
                      </div>
                    </div>}
                  </Grid>
                </Grid>
              </div>
            </CustomContainer>
          </div>
        </div>
      </div>
    </div>
  )

}
const mapStateToProps = state => ({
  userToken: {
    jwtAccessToken: state.aad.accessToken ? state.aad.accessToken.accessToken : '',
    idToken: state.aad.idToken ? state.aad.idToken.idToken.rawIdToken : '',
    userDetails: state.aad.account,
    clientId: state.app.clientid,
    domain: state.app.domain,
    prefix: state.app.prefix,
    tid: state.aad.account ? state.aad.account.idToken.tid : '',
  },
  redirectUris: state.app.redirectUris
});
export default
  connect(
    mapStateToProps,
  )(TenantRegistration);
